import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Typography from '../../../components/common/Typography';
import Button from '../../../components/common/Button';
import OptionCard from '../../../components/common/OptionCard';

import previousAiIcon from '../../../asset/img/previous_ai.svg';
import previousTypingIcon from '../../../asset/img/previous_typing.svg';

const InputMethodStep = ({ onSelectAi, onSelectManual }) => {
  const { t } = useTranslation('previousEmployment');
  const [selectedMethod, setSelectedMethod] = useState(null); // 'ai' | 'manual' | null

  const handleNext = () => {
    if (selectedMethod === 'ai') {
      onSelectAi();
    } else if (selectedMethod === 'manual') {
      onSelectManual();
    }
  };

  return (
    <div className="displayFlexColumn" style={{ gap: '24px' }}>
      {/* 제목 */}
      {/* 업로드 된 영수증의 내용은 어떻게 할까요? */}
      <Typography variant="subtitleBold">{t('inputMethodSection.title')}</Typography>

      {/* 선택 카드 */}
      <div className="displayFlexColumn" style={{ gap: '12px' }}>
        {/* AI 반영 옵션 */}
        <OptionCard
          isActive={selectedMethod === 'ai'}
          onClick={() => setSelectedMethod('ai')}
          icon={previousAiIcon}
          iconAlt="AI"
          title={t('inputMethodSection.aiOption.title')}
          description={t('inputMethodSection.aiOption.description')}
        />

        {/* 수동 입력 옵션 */}
        <OptionCard
          isActive={selectedMethod === 'manual'}
          onClick={() => setSelectedMethod('manual')}
          icon={previousTypingIcon}
          iconAlt="Manual"
          title={t('inputMethodSection.manualOption.title')}
          description={t('inputMethodSection.manualOption.description')}
        />
      </div>

      {/* 다음으로 버튼 */}
      {/* 다음으로 */}
      <Button
        color="primary"
        onClick={handleNext}
        disabled={!selectedMethod}
        value={t('inputMethodSection.nextButton')}
      />
    </div>
  );
};

export default InputMethodStep;
